export const cargaMasiva = {
  CANTIDAD: 100
}
